import { computed } from 'vue';
import { useDepartmentStore } from '../model/department.store';
import { useCustomToast } from '@/shared/lib';

/**
 * Composable for department management operations
 * Provides high-level methods for creating departments and managing related state
 */
export function useDepartmentManagement() {
  const store = useDepartmentStore();
  const toast = useCustomToast();

  // ===== COMPUTED =====
  const isCreating = computed(() => store.isCreating);
  const error = computed(() => store.error);

  // ===== METHODS =====
  async function createDepartmentWithPositions(
    code: string,
    positionIds: number[]
  ): Promise<{ success: boolean }> {
    const success = await store.createDepartmentWithPositions(code, positionIds);

    if (success) {
      toast.showSuccessToast({
        title: 'Departamento criado com sucesso',
        type: 'success',
      });
    } else {
      const message = store.error ?? undefined;
      toast.showErrorToast({
        title: 'Erro ao criar departamento, tente novamente.',
        ...(message && { message }),
        type: 'error',
      });
    }

    return { success };
  }

  return {
    // State
    isCreating,
    error,
    // Actions
    createDepartmentWithPositions,
  };
}
